// custom.js
// Toggle Ellipsis functionality for Prestige theme

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('toggle-ellipsis').forEach(el => {
    const contentEl = el.querySelector('[data-content]');
    const btn       = el.querySelector('[data-button]');
    const height    = parseInt(el.getAttribute('data-height'), 10);

    // Initial clamp
    contentEl.style.maxHeight = height + 'px';

    // Toggle expand/collapse on button click
    btn.addEventListener('click', () => {
      const isExpanded = el.classList.toggle('toggle-ellipsis--expanded');
      if (isExpanded) {
        // Remove clamp to show full content
        contentEl.style.maxHeight = 'none';
        btn.innerHTML = `<span>Read less</span>`;
      } else {
        // Re-apply clamp
        contentEl.style.maxHeight = height + 'px';
        btn.innerHTML = `<span>Read more</span>`;
      }
    });

    // Hide button if content shorter than clamp height
    if (contentEl.scrollHeight <= height) {
      const actions = el.querySelector('[data-actions]');
      if (actions) actions.style.display = 'none';
    }
  });
});

if (!customElements.get('product-card-slider')) {
  customElements.define('product-card-slider', class extends HTMLElement {
    connectedCallback() {
      const slider = this.querySelector('.product-card__slider');
      const slides = [...this.querySelectorAll('.product-card__slide')];
      const dots = [...this.querySelectorAll('.product-card__slider-dots span')];
      if (!slider || slides.length < 2) return;

      this._io = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.intersectionRatio < 0.5) return;
          const i = slides.indexOf(entry.target);
          dots.forEach((d, j) => d.classList.toggle('is-active', j === i));
        });
      }, { root: slider, threshold: 0.5 });

      slides.forEach((s) => this._io.observe(s));
    }
    disconnectedCallback() { this._io?.disconnect(); }
  });
}
